import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  useLazyDownloadSolarEstimationSummaryQuery,
  useLazyDownloadSolarEstimationTimelineQuery,
} from "../../../../../redux/api/solar-estimation/solarEstimationAPI";
import { EstimationExportFileFormat } from "../../../../../shared/oversight-core/enums/estimation-export-file-format";
import AppSelect, {
  Option,
} from "../../../../../shared/oversight-core/ui-elements/app-select/app-select";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../../shared/oversight-core/ui-elements/modal-container/modal-container";
import { downloadFile } from "../../../../../shared/oversight-core/utils/download-file";
import { showErrorMessage } from "../../../../../shared/oversight-core/utils/toast";

interface IProps extends ModelContainerProps {
  show: boolean;
  estimationId: string;
  isTimeline?: boolean;
}

const estimationFormatOptions: Option[] = [
  { value: EstimationExportFileFormat.PDF, label: "PDF" },
  {
    value: EstimationExportFileFormat.CSV,
    label: "CSV",
  },
  {
    value: EstimationExportFileFormat.XLSX,
    label: "XLSX",
  },
];

const EstimationSummaryExportModal = (props: IProps) => {
  const { show, estimationId, isTimeline = false, ...rest } = props;

  const [selectedFormat, setSelectedFormat] = useState<Option>({
    ...estimationFormatOptions[0],
  });

  const [
    triggerDownloadEstimationSummary,
    { isFetching: isDownloadingSummary },
  ] = useLazyDownloadSolarEstimationSummaryQuery();
  const [
    triggerDownloadEstimationTimeline,
    { isFetching: isDownloadingTimeline },
  ] = useLazyDownloadSolarEstimationTimelineQuery();

  const onDownloadEstimationSummary = () => {
    if (estimationId && selectedFormat.value) {
      triggerDownloadEstimationSummary({
        estimationId,
        format: selectedFormat.value as EstimationExportFileFormat,
      })
        .unwrap()
        .then((res: Blob) => {
          downloadFile(res);
          setSelectedFormat({ ...estimationFormatOptions[0] });
          props.onClose?.();
        })
        .catch(() => {
          showErrorMessage("Failed to export estimation summary");
        });
    }
  };

  const onDownloadEstimationTimeline = () => {
    if (estimationId && selectedFormat.value) {
      triggerDownloadEstimationTimeline({
        estimationId,
        format: selectedFormat.value as EstimationExportFileFormat,
      })
        .unwrap()
        .then((res: Blob) => {
          downloadFile(res);
          setSelectedFormat({ ...estimationFormatOptions[0] });
          props.onClose?.();
        })
        .catch(() => {
          showErrorMessage("Failed to export estimation timeline");
        });
    }
  };

  return (
    <ModalContainer
      {...rest}
      title={
        isTimeline ? "Export Estimation Timeline" : "Export Estimation Summary"
      }
      show={show}
      size="modal-md"
      confirmButtonText="Export"
      isLoading={isDownloadingSummary || isDownloadingTimeline}
      onConfirm={
        isTimeline ? onDownloadEstimationTimeline : onDownloadEstimationSummary
      }
    >
      <Row>
        <Col>
          <AppSelect
            label="Select Export Format"
            options={estimationFormatOptions}
            selectedValue={selectedFormat}
            onChangeOption={(selectOption) => {
              setSelectedFormat(selectOption);
            }}
            className="text-light font-size-14"
          />
        </Col>
      </Row>
    </ModalContainer>
  );
};

export default EstimationSummaryExportModal;
